import { RootWrapper } from "./src/components/RootWrapper";
import './src/styles/_variables.scss';

export const onClientEntry = () => {
  document.documentElement.setAttribute("lang", "en");
};

export const wrapRootElement = RootWrapper;
